import times from 'lodash/times'
import React from 'react'
import MediaItem from 'components/ui/media-item'
import PaneItem from 'components/ui/pane-item'
import Skeleton from 'components/ui/skeleton'
type Props = {
  itemsCount?: number
}

const PaneItemsSkeleton = ({ itemsCount = 10 }: Props): React.ReactNode[] => {
  return times(
    itemsCount,
    (index: number): React.ReactNode => (
      <PaneItem
        key={`skeleton-search-${index}`}
        content={
          <MediaItem
            media={<Skeleton type="block" />}
            title={<Skeleton />}
            caption={<Skeleton />}
          />
        }
      />
    ),
  )
}

export default PaneItemsSkeleton
